import { Button, Popover } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";

const HOW_TO_USE_STEPS = [
  {
    title: "Set design milestones",
    description:
      "Add or remove milestones and enter dates committed by the design team for each stage (e.g., 50% DD, 100% CD)."
  },
  {
    title: "Add Bid Packages",
    description:
      "Link relevant Bid Packages; packages are linked to the last design milestone by default."
  },
  {
    title: "Map bid dependencies",
    description:
      "Coordinate with the design team to connect each bid package to its preceding design milestone."
  },
  {
    title: "Track buyout risk",
    description:
      "Track bid issue dates against design progress - red highlights indicate high risk."
  }
];

function HowToUseContent() {
  return (
    <div
      className="w-[360px] leading-normal"
      data-testid="planner-how-to-use-content"
    >
      <div className="flex flex-col gap-1 px-4 pb-3 pt-3.5">
        <div className="text-sm font-semibold text-ciq-gray-960">
          How to use Design Package
        </div>
        <div className="text-xs text-ciq-planner-ink4">
          Align buyout timelines with design deliverable milestones.
        </div>
      </div>
      <ol className="m-0 flex list-none flex-col gap-2.5 border-0 border-t border-solid border-ciq-gray-100 px-4 py-3.5">
        {HOW_TO_USE_STEPS.map((step, index) => (
          <li key={step.title} className="flex items-start gap-2.5">
            <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-ciq-planner-accent-bg text-[11px] font-semibold text-ciq-planner-accent">
              {index + 1}
            </span>
            <div className="flex min-w-0 flex-1 flex-col gap-0.5">
              <div className="text-xs font-medium text-ciq-gray-960">
                {step.title}
              </div>
              <div className="text-[11px] text-ciq-planner-ink3">
                {step.description}
              </div>
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
}

export default function HowToUsePopover() {
  return (
    <Popover
      content={<HowToUseContent />}
      trigger="click"
      placement="bottomRight"
      arrow={false}
      // The panel brings its own padding; antd's default container padding
      // would push it past the 360px design width.
      styles={{
        container: {
          padding: 0,
          borderRadius: 8,
          boxShadow:
            "0px 3px 6px -4px rgba(0, 0, 0, 0.12), 0px 6px 16px rgba(0, 0, 0, 0.08)"
        }
      }}
    >
      <Button
        icon={<QuestionCircleOutlined />}
        iconPlacement="end"
        data-testid="planner-how-to-use-button"
      >
        How to Use
      </Button>
    </Popover>
  );
}
